import React from "react";
import "./index.scss";

const exceptThisSymbols = ["e", "E", "+", "-", "."];

const MainInput = ({
  value,
  onChange,
  className,
  label,
  errorMessage,
  disabled,
  type = "text",
  placeholder=""
}) => {
  const handleChange = (e) => {
    const newValue = e.target.value;

    if (type === "number") {
      // Remove invalid characters and format the value
      let cleanedValue = e.target.value.replace(/[^0-9]/g, "");
      if (
        cleanedValue.startsWith("0") &&
        cleanedValue.length > 1 &&
        !cleanedValue.includes(".")
      ) {
        cleanedValue = cleanedValue.replace(/^0+/, "");
      }

      if (cleanedValue !== newValue) {
        e.target.value = cleanedValue;
      }

      const numericValue =
        cleanedValue === "" ? "" : parseFloat(cleanedValue).toString();
      e.target.value = numericValue;
    }

    onChange(newValue);
  };
  const detectTheme = () => {
    return JSON.parse(localStorage.getItem("theme_config")) ? JSON.parse(localStorage.getItem("theme_config")).theme : "light"
  }
  return (
    <section className="input-container">
      {label && <section className="main-label">{label}</section>}
      <input
      placeholder={placeholder|| ""}
        onKeyDown={(e) => {
          if (type === "number") {

            return exceptThisSymbols.includes(e.key) && e.preventDefault()
          }
          return false
        }
        }
        disabled={disabled}
        className={` ${disabled ? "disabled" : ""} ${className || ""} ${detectTheme()} main-input ${errorMessage ? "input-error" : ""}`}
        type={type}
        value={value}
        onChange={(e) => handleChange(e)}
        min={type === "number" ? 0 : undefined}
        step={type === "number" ? "any" : undefined} // Allows decimals
      />
      {errorMessage && (
        <section className="main-error-label">{errorMessage}</section>
      )}
    </section>
  );
};

export default MainInput;
